module.exports = __webpack_public_path__ + "img/1726035053508-screenshot-1726034933932.png.efacea3e.webp";